export enum SOCIAL_PROVIDERS {
    FACEBOOK = "facebook",
    GOOGLE = "google",
}
